const state = {
  name: null,
  department_ids: [],
  email: null,
  full_name: null,
  id: null,
  id_card: null,
  phone_number: null
}

const mutations = {
  ADD_USER_INFO: (state, data) => {
    Object.assign(state, data)
  }
}

const actions = {
  addUserInfo({ commit }, data) {
    commit('ADD_USER_INFO', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
